<!-- Empty layout -->
@if (layout === "empty") {
    <empty-layout></empty-layout>
}

<!-- Classic layout (vertical navigation) -->
@if (layout === "classic") {
    <classic-layout></classic-layout>
}
